import styled from 'styled-components';
import { Form } from 'antd';

export const ProfileInputWrapper = styled(Form.Item)<{ type: string }>`
    width: 100%;

    .ant-input {
        padding: 12px;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 14px;
        ${({ type }) => type === "password" && `
            height: 40px;
        `}
        @media (max-width: 768px) {
            padding: 10px;
            font-size: 13px;
        }

        &:disabled {
            background-color: #f5f5f5;
            color: #666;
        }
    }
`;

export const Label = styled.div`
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;

    @media (max-width: 768px) {
        font-size: 13px;
        margin-bottom: 6px;
    }
`; 